var _ = require('underscore');
var sw = require('js/lib/sw');
var Backbone = require('backbone');
var CustomMakerModel = require('./CustomMakerModel');
var CocreatorFormField = require('./CocreatorFormField');
var CocreatorVariableAttribute = require('./CocreatorVariableAttribute');
var FastModel = require('./FastModel');
var ModelCocreator = require('./ModelCocreator');
var Product = require('./Product');
var ShapeJsModel = require('./ShapeJsModel');
var ProductEditModel = require('./ProductEditModel');
var ProductDiscoverabilityModel = require('./ProductDiscoverabilityModel');
var ShapewaysModel = require('./ShapewaysModel');
var swUtils = require('js/lib/sw-utils');

var MODEL_TYPE_PRODUCT_EDIT_MODEL = 'ProductEditModel';

// We will be using this as a storage place for our model collections
sw.models = sw.models || {};
var ModelManager = _.extend({
  toJSON: function toJSON() {
    var json = {};

    _.each(sw.models, function serializeJSON(ModelCollection) {
      json[ModelCollection.model.prototype.pluralName] = ModelCollection.toJSON();
    });

    return json;
  }
}, Backbone.Events);

/**
 * Registers the dispatcher in the model
 *
 * @param model
 * @private
 */
function _registerDispatcher(model) {
  if(model.dispatchObserver) {
    model.listenTo(sw, sw.SW_ACTION_EVENT, model.dispatchObserver);
  }
}

/**
 *
 *  Fetch model data from the server if that's an option
 *  Since Backbone's default url style doesn't serve our
 *  purposes, we'll need to make sure we have an endpoint
 *  for the model we're fetching, and we'll need to explicitly
 *  specify that url on the model itself.
 *
 * @param Model BackboneModelClass
 * @param model model instance
 * @private
 */
function _fetchInitialData(Model, model) {
  var data = sw.data[Model.prototype.pluralName] || {};
  var id = model.id;

  if (!data[id] && Model.prototype.hasOwnProperty('url')) {
    model.fetch();
  }
}

/**
 *
 * We prepopulate sw data with bootstrapped attributes for the
 * models we will need on page. If this data exists, we should
 * use it to prepopulate our models.
 *
 * Otherwise create new models.
 *
 * @param Model
 * @param id
 * @returns {{}}
 * @private
 */
function _bootstrapAttributes(Model, id) {
  var data = sw.data[Model.prototype.pluralName] || {};
  var attrs = {};

  /**
   * Backbone Models let you specify an idAttribute per Entity.
   * Defaults to 'id'
   *
   * @see  http://backbonejs.org/#Model-idAttribute
   *
   */
  attrs[Model.prototype.idAttribute] = id;

  if (data[id]) {
    attrs = swUtils.cloneDataObject(data[id]);
  }

  return attrs;
}

function _getCollection(Model) {
  if (!sw.models[Model.prototype.pluralName]) {
    var collection = new Backbone.Collection([], {
      model: Model
    });

    ModelManager.listenTo(collection, 'all', function(eventName) {

      var args = Array.prototype.slice.apply(arguments).splice(1);
      args.unshift(Model.prototype.pluralName + ':' + eventName);

      this.trigger.apply(this, args);
    }, ModelManager);

    sw.models[Model.prototype.pluralName] = collection;
  }

  return sw.models[Model.prototype.pluralName];
}

/**
 * Creates a getter for a Backbone Collection.
 *
 * This is intended to be used for listening
 * purposes only.
 *
 * These collections are not gauranteed to
 * by hydrated with all bootstrapped page data.
 *
 * To get an individual model, use the get method
 * for that model
 *
 * @param  {[type]} Model [description]
 * @return {[type]}       [description]
 */
// function makeCollectionGetter(Model) {
//   return function getCollectionMeta() {

//     return _getCollection(Model);
//   };
// }


function makeModelGetter(Model, options) {

  options = options || {};

  return function getModelMeta(id) {
    var collection = _getCollection(Model);
    var model = collection.get(id);

    if (!model) {
      var attrs = _bootstrapAttributes(Model, id);
      model = new Model(attrs);

      _fetchInitialData(Model, model);
      _registerDispatcher(model);

      collection.add(model);

    }

    return model;
  };
}

/**
 *
 * Checks to see if a model with the supplied id has
 * been instantiated in the proper collection.
 *
 * @param  {int} id
 * @return {bool}
 */
function makeModelChecker(Model) {

  return function checkModelMeta(id) {
    var collection = _getCollection(Model);
    var data = sw.data[Model.prototype.pluralName] || {};

    var model = collection.get(id);

    return !!(model || data[id]);
  };
}

function makeCollectionMultipleGetter(Model, options) {
  var modelGetter = makeModelGetter(Model, options);

  return function getCollectionMeta(ids) {
    ids = ids || [];

    var collection = new Backbone.Collection([], {
      model: Model
    });

    _.each(ids, function addToCollection(id) {
      var model = modelGetter(id);
      collection.add(model);
    });

    return collection;
  };
}

ModelManager = _.extend(ModelManager, {

  getCocreatorFormField:                    makeModelGetter(CocreatorFormField),
  getCocreatorFormFieldMultiple:            makeCollectionMultipleGetter(CocreatorFormField),
  checkCocreatorFormField:                  makeModelChecker(CocreatorFormField),

  getCocreatorVariableAttribute:            makeModelGetter(CocreatorVariableAttribute),
  getCocreatorVariableAttributeMultiple:    makeCollectionMultipleGetter(CocreatorVariableAttribute),
  checkCocreatorVariableAttribute:          makeModelChecker(CocreatorVariableAttribute),

  getModelCocreator:                        makeModelGetter(ModelCocreator),
  getModelCocreatorMultiple:                makeCollectionMultipleGetter(ModelCocreator),
  checkModelCocreator:                      makeModelChecker(ModelCocreator),

  getCustomMakerModel:                      makeModelGetter(CustomMakerModel),
  getCustomMakerModelMultiple:              makeCollectionMultipleGetter(CustomMakerModel),
  checkCustomMakerModel:                    makeModelChecker(CustomMakerModel),

  getFastModel:                             makeModelGetter(FastModel),
  getFastModelMultiple:                     makeCollectionMultipleGetter(FastModel),
  checkFastModel:                           makeModelChecker(FastModel),

  getProduct:                               makeModelGetter(Product),
  getProductMultiple:                       makeCollectionMultipleGetter(Product),
  checkProduct:                             makeModelChecker(Product),

  getShapeJs:                               makeModelGetter(ShapeJsModel),
  getShapeJsMultiple:                       makeCollectionMultipleGetter(ShapeJsModel),
  checkShapeJs:                             makeModelChecker(ShapeJsModel),

  getProductEdit:                           makeModelGetter(ProductEditModel),
  getProductEditMultiple:                   makeCollectionMultipleGetter(ProductEditModel),
  checkProductEdit:                         makeModelChecker(ProductEditModel),

  getProductDiscoverability:                makeModelGetter(ProductDiscoverabilityModel),
  getProductDiscoverabilityMultiple:        makeCollectionMultipleGetter(ProductDiscoverabilityModel),
  checkProductDiscoverability:              makeModelChecker(ProductDiscoverabilityModel),

  getViewState:                             makeModelGetter(ShapewaysModel),

  /**
   * Given a model name and id returns the appropriate model.
   *
   * This makes it possible to create generic components that
   * can work for any model such as ListChooserView.
   *
   * @param  string type
   * @param  string id
   * @return ShapewaysModel
   */
  getModelByTypeAndId:                      function getModelByTypeAndId(type, id) {
    switch(type) {
      case MODEL_TYPE_PRODUCT_EDIT_MODEL:
        return this.getProductEdit(id);
    }

    return new Backbone.Model();
  },

  /**
   *
   * Creates a new polling instance
   *
   * @param title
   * @param callback
   */
  amdNewPollingInstance: function(title, callback, uploadComplete) {
    require(['js/lib/models/PollingInstance'], function(PollingInstance) {
      var collection = _getCollection(PollingInstance);

      var model = new PollingInstance({
        title:            title,
        uploadComplete:   uploadComplete
      });
      _fetchInitialData(PollingInstance, model);
      _registerDispatcher(model);

      collection.add(model);

      callback(model);

    });
  },

  /**
   * AMD getter for polling status models
   *
   * @param clientId
   * @param callback
   */
  amdPollingInstanceByClientId: function(clientId, callback) {
    require(['js/lib/models/PollingInstance'], function(PollingInstance) {

      var collection = _getCollection(PollingInstance);

      var model = collection.find(function(model) {
        return model.cid === clientId;
      });

      callback(model);

    });
  },

  /**
   * AMD getter for polling status models
   *
   * @param id
   * @param callback
   */
  amdPollingInstanceById: function(id, callback) {

    require(['js/lib/models/PollingInstance'], function(PollingInstance) {
      var collection = _getCollection(PollingInstance);

      var model = collection.get(parseInt(id, 10));

      if (!model) {

        var attrs = _bootstrapAttributes(PollingInstance, id);
        model = new PollingInstance(attrs);

        _fetchInitialData(PollingInstance, model);
        _registerDispatcher(model);
        collection.add(model);
      }

      callback(model);

    });
  },

  /**
   *
   * Finds all polling statuses where
   * status is polling
   *
   * @param callback
   */
  amdActivePollingInstances: function(callback) {
    require(['js/lib/models/PollingInstance'], function(PollingInstance) {

      var collection = _getCollection(PollingInstance);

      var models = collection.where({
        polling: true
      });

      callback(models);

    });
  },

  /**
   * Get or create a model by model id
   *
   * @param modelId
   * @param callback
   */
  amdNewModelInstance: function amdNewRecaptchaInstance(modelId, callback) {
    require(['js/lib/models/RecaptchaModel'], function(RecaptchaModel) {
      var model = makeModelGetter(RecaptchaModel)(modelId);
      callback(model);

    });
  },

  /**
   * Get or create a new model edit model by ID
   *
   * @param modelId
   * @param callback
   */
  amdNewModelEditModel: function amdNewModelEditModel(modelId, callback) {
    require(['js/lib/models/ModelEditModel'], function (ModelEditModel) {
      var model = makeModelGetter(ModelEditModel)(modelId);
      callback(model);
    });
  }

});

window.ModelManager = ModelManager;

module.exports = ModelManager;
